var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOpenedEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.375 13.667c.345 0 .625-.28.625-.625v-7.02c0-.856-.43-1.643-1.152-2.105l-1.504-.964V.625A.625.625 0 0012.719 0H3.28a.625.625 0 00-.625.625v2.326l-1.503.961A2.49 2.49 0 000 6.018V13.5C0 14.879 1.121 16 2.5 16h11c1.379 0 2.5-1.121 2.5-2.5a.625.625 0 10-1.25 0c0 .69-.56 1.25-1.25 1.25h-11c-.69 0-1.25-.56-1.25-1.25V6.832l5.43 3.377c.407.253.863.38 1.32.38.456 0 .913-.127 1.32-.38l5.43-3.377v6.21c0 .345.28.625.625.625zm-1.2-8.698c.188.121.336.287.435.478l-1.266.788V4.438l.83.531zM1.825 4.965l.83-.53v1.8l-1.268-.789c.1-.192.249-.36.438-.48zM8.66 9.147a1.242 1.242 0 01-1.32 0L3.906 7.012V1.25h8.188v5.762L8.66 9.147z",
    fill: "#262626"
  })));
}

export default __webpack_public_path__ + "./fonts/opened-email.a45fd4973b474705cd160cd19b729b49.svg";
export { SvgOpenedEmail as ReactComponent };